export enum Breakpoints {
  mobile = "max-width: 680px",
  tablet = "max-width: 1024px",
} //TODO: decalre all needed breakpoints
